import { Routes } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './services/auth.guard';
import { RoleGuard } from './services/role.guard';
import { AddEditLayoutComponent } from './admissions/layouts/add-edit-layout/add-edit-layout.component';
import { DocumentsComponent } from './portal/documents/documents.component';
import { MeetingSchedulerComponent } from './shared/meeting-scheduler/meeting-scheduler.component';
import { MeetingCancellationComponent } from './shared/meeting-scheduler/meeting-cancellation/meeting-cancellation.component';
import { ApplicationDynamicFormComponent } from './portal/dynamic-applications/application-dynamic-form';
import { GoalsListComponent } from './pages/goals/goals-list/goals-list.component';
import { AdminIdGuard } from './services/admin-id.guard';
import { RcOauthCallbackComponent } from './profile/company/sms-provider/rc-oauth-callback.component';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/admissions/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./profile/profile.route').then((m) => m.routeProfile),
      },
      {
        path: 'admin',
        canActivate: [AuthGuard,AdminIdGuard],
        loadChildren: () =>
          import('./admin-view/admin-view.route').then((m) => m.routeAdmin),
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./forms/forms.route').then((m) => m.formsRoutes),
      },
      {
        path: 'goals',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN'] },
        loadChildren: () =>
          import('./pages/goals/page.route').then((m) => m.goalRoute),
      },
      {
        path: 'admissions',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN', 'USER'] },
        loadChildren: () =>
          import('./admissions/admissions.routes').then(
            (m) => m.AdmissionsRoutes,
          ),
      },
      {
        path: 'leads',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN', 'USER'] },
        loadChildren: () =>
          import('./leads/admissions.routes').then((m) => m.leadsRoute),
      },
      {
        path: 'lead-pipeline',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN', 'USER'] },
        loadChildren: () =>
          import('./lead-pipeline/pipeline.routes').then((m) => m.pipelineRoute),
      },
      {
        path: 'reports',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN', 'USER'] },
        loadChildren: () =>
          import('./reports/routing-reports').then((m) => m.reportRoute),
      },
      {
        path: 'activities',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN', 'USER'] },
        loadChildren: () =>
          import('./activities/activities.routes').then((m) => m.activitiesRoute),
      },
      {
        path: 'inbox',
        loadChildren: () => import('./inbox/inbox.module').then(m => m.InboxModule),
        canActivate: [AuthGuard], // your auth guard
      },
    ],
  },
  {
    path: 'portal',
    component: FullComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['LEAD'] },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./portal/portal.routes').then((m) => m.portalRoute),
      },
    ]
  },
  {
    path: 'application/:isAdmin/:lead_id',
    component: ApplicationDynamicFormComponent,
  },
  {
    path: 'financial-aid/:isAdmin/:lead_id',
    component: ApplicationDynamicFormComponent,
  },
  {
    path: 'documents-student/:lead_id',
    component: DocumentsComponent,
  },
  {
    path: 'meeting-schedule/:id/reschedule/:scheduleId',
    component: MeetingSchedulerComponent,
  },
  {
    path: 'meeting-schedule/:id/cancel/:cancelScheduleId',
    component: MeetingCancellationComponent,
  },
  {
    path: 'meeting-schedule/:id',
    component: MeetingSchedulerComponent,
  },
  {
    path: 'meeting-schedule/:id/thank-you-page',
    component: MeetingSchedulerComponent,
  },
  {
    path: 'company-settings/rc-callback',
    component: RcOauthCallbackComponent,
  },
  {
    path: 'authentication',
    loadChildren: () =>
      import('./authentication/authentication.router').then(
        (m) => m.PagesRoutes,
      ),
  },
  {
    path: 'published-forms',
    loadChildren: () =>
      import('./published-forms/published.route').then((m) => m.publishedFomsRoute),
  },
  {
    path: 'admissions/layouts/new',
    canActivate: [AuthGuard],
    component: AddEditLayoutComponent,
  },
  {
    path: 'admissions/layouts/:id',
    canActivate: [AuthGuard],
    component: AddEditLayoutComponent,
  },
  // Add embed routes (no auth required)
  {
    path: 'embed/application/:id',
    component: ApplicationDynamicFormComponent,
    data: { 
      isEmbed: true,
      noAuth: true,
      type: 'lead_application'
    }
  },
  {
    path: 'embed/financial-aid/:id',
    component: ApplicationDynamicFormComponent,
    data: { 
      isEmbed: true,
      noAuth: true,
      type: 'financial_aid'
    }
  },
  {
    path: '**',
    redirectTo: '/admissions/dashboard',
  },
];